import * as Yup from 'yup'
import moment from 'moment'
import { useFormik } from 'formik'
import { useState, useEffect } from 'react'
import AddIcon from '@material-ui/icons/Add'
import InputAdornment from '@material-ui/core/InputAdornment'
import ImportExportIcon from '@material-ui/icons/ImportExport'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded'

import { Colors } from '~/styles'
import { ConvertLocalTimeGet, ConvertLocalTimePost } from '~/utils'
import {
  Input,
  Button,
  InputSelect,
  InputDateTime,
  EquipmentIcon,
  FolderDocument,
  ModalConfirmation
} from '~/components'

import SC from './styled.activity'
import Funcs from './functions.activity'
import Popover from './popover'
import { Checkbox, FormControl, MenuItem, Select } from '@material-ui/core'
import { Images } from '../../../../assets'

// ========================= FORM SECTION=========================
const DurationInput = ({ form }) => (
  <SC.DurationInputContainer>
    <SC.DurationLabel>Forecast Berthing Duration</SC.DurationLabel>
    <SC.DurationInputWrapper>
      <Input
        form={form}
        type='number'
        placeholder='Hour'
        name='Forecast_Berth_Dur_Hour'
        id='exct-mdl-act-forecast-berth-dur-hour-input'
        InputProps={{
          readOnly: true,
          endAdornment: <InputAdornment position='end'>Hour(s)</InputAdornment>
        }}
      />
      <Input
        form={form}
        type='number'
        placeholder='Minute'
        name='Forecast_Berth_Dur_Minute'
        id='exct-mdl-act-forecast-berth-dur-minute-input'
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position='end'>Minute(s)</InputAdornment>
          )
        }}
      />
    </SC.DurationInputWrapper>
  </SC.DurationInputContainer>
)

const TopForm = ({ form }) => (
  <SC.TopFormWrapper>
    <InputDateTime
      form={form}
      readOnly={true}
      name='Forecast_Arrival'
      label='Forecast Arrival'
      id='exct-mdl-act-forecast-arrival-date'
    />
    <InputDateTime
      form={form}
      readOnly={true}
      name='Forecast_Depart'
      label='Forecast Departure'
      id='exct-mdl-act-forecast-depart-date'
    />
    <DurationInput form={form} />
  </SC.TopFormWrapper>
)

const ListActivityCell = ({
  index,
  activity,
  location,
  handleOpenActivityDetail,
  handleCheckProgressActivity
}) => {
  const handleChange = () => {
    handleOpenActivityDetail(activity)
  }

  const isChecked = (() => {
    return activity.start_date ? true : false
  })()

  const payload = (() => {
    const startDate = moment(new Date()).format()

    const finishDate = Funcs.findTheLatestDateFromTasksList(
      activity.progress_task_header_list ?? []
    )

    return {
      ...activity,
      progress: 0,
      id: activity.id,
      sr_code: activity.sr_code,
      start_date: ConvertLocalTimePost(location, startDate),
      modified_date: ConvertLocalTimePost(location, new Date()),
      finish_date:
        finishDate !== '1970-01-01T07:00:00+07:00'
          ? ConvertLocalTimePost(location, finishDate)
          : null
    }
  })()

  return (
    <SC.ActivityCellWrapper>
      <SC.KeyboardArrowDownIcon
        id={`exct-mdl-act-arrow-down-${index}`}
        isOpen={activity.isOpen}
        onClick={handleChange}
      />
      {activity.activity_type === 'Manual' && (
        <SC.GreenCheckbox
          color='default'
          checked={isChecked}
          disabled={isChecked}
          id={`exct-mdl-act-checkbox-${index}`}
          onChange={() => handleCheckProgressActivity(payload)}
        />
      )}

      {activity.activity_type === 'Checklist' && (
        <div style={{
          width: 8,
          height: 8,
          marginRight: 8,
          borderRadius: '100%',
          backgroundColor: activity.color_status,
        }}></div>
      )}
      <span>{activity.activity_name} {activity.progress_task_counter}</span>
    </SC.ActivityCellWrapper>
  )
}

const HeaderGrid = () => (
  <SC.THead>
    <SC.HeaderRowGrid>
      <th width='auto'>List Activity</th>
      <th width='252px'>Start Date</th>
      <th width='252px'>Finish Date</th>
      <th width='203px'>Progress</th>
      <th width='107px'></th>
    </SC.HeaderRowGrid>
  </SC.THead>
)

const DetailGridHeader = ({ activity, setActivityList }) => (
  <thead>
    <SC.InnerGridHeader>
      <th width='100px'>Action</th>
      <th width='50px'>No</th>
      <th width='200px'>Task</th>
      {activity.activity_type === 'Checklist' && (
        <>
          <th width='200px'>PIC</th>
          <th width='200px'>Level</th>
          <th width='150px'>
            <div style={{ width: '100%', textAlign: 'center', marginBottom: 4 }}>Status</div>
            {activity.progress_task_header_list && (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ height: 16, width: '33%', backgroundColor: Colors.newGreen }}></span>
                <span style={{ height: 16, width: '33%', backgroundColor: Colors.newOrange }}></span>
                <span style={{ height: 16, width: '33%', backgroundColor: Colors.newRed }}></span>
              </div>
            )}
          </th>
        </>
      )}
      <th width='280px'>Planning</th>
      <th width='350px'>Remarks</th>
      <th width='250px'>Start Date</th>
      <th width='250px'>Finish Date</th>

      {activity.activity_type === 'Manual' && (
        <th width='200px'>Percentage</th>
      )}
      <th width='104px'>
        <ButtonOrder activity={activity} setActivityList={setActivityList} />
      </th>
    </SC.InnerGridHeader>
  </thead>
)

const ButtonOrder = ({ activity, setActivityList }) => {
  const [dataSort, setDataSort] = useState([])
  const [modal, setModal] = useState(false)
  return (
    <div style={{ position: 'relative' }}>
      <SC.ButtonSort onClick={() => setModal(true)}>
        <ImportExportIcon /> Sort
      </SC.ButtonSort>
      {modal && (
        <SortModal
          dataSort={dataSort}
          activity={activity}
          setActivityList={setActivityList}
          setModalChild={(e) => setModal(e)}
          setDataSortChild={(e) => setDataSort(e)}
        />
      )}
    </div>
  )
}
const AddTaskRow = ({ index, activity, addNewTask, provided }) => {
  const [taskDescription, setTaskDescription] = useState('')

  // The user can't add new task if the activity is not checked
  const isChecked = (() => {
    return activity.start_date ? true : false
  })()

  const disableAddTask = (() => {
    return !isChecked || taskDescription === ''
  })()

  const handleChangeTaskDescription = (event) => {
    setTaskDescription(event.target.value)
  }

  const handleAddNewTask = () => {
    addNewTask(activity, taskDescription)
    setTaskDescription('')
  }

  return (
    <tr
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
    >
      <td colSpan={8}>
        <SC.AddTaskCell>
          <SC.AddTaskInput
            disabled={!isChecked}
            value={taskDescription}
            onChange={handleChangeTaskDescription}
            // id={`exct-mdl-act-add-task-input${activity.code}`}
            id={`exct-mdl-act-add-task-input-${index}`}
          />
          <SC.AddTaskButtonWrapper>
            <Button
              type='submit'
              onClick={handleAddNewTask}
              // id={`exct-mdl-act-add-task-btn${activity.code}`}
              id={`exct-mdl-act-add-task-btn-${index}`}
              disable={disableAddTask}
              color={disableAddTask ? 'grey' : Colors.newGreen}
            >
              Add Task
            </Button>
          </SC.AddTaskButtonWrapper>
        </SC.AddTaskCell>
      </td>
    </tr>
  )
}

const EmptyList = ({ colSpan = 6, text }) => (
  <tr>
    <td colSpan={colSpan}>
      <SC.EmptyListCell>{text}</SC.EmptyListCell>
    </td>
  </tr>
)

const InViewTaskHeaderRow = ({
  index,
  task,
  activity,
  location,
  provided,
  snapshot,
  deleteTask,
  getItemStyle,
  toggleEditMode,
  handleShowModal,
  toggleModalTaskAttachment,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedTask, setSelectedTask] = useState()

  const planStart = ConvertLocalTimeGet(
    location,
    task.plan_start_time,
    'DD-MM-YYYY HH:mm'
  )
  const planFinish = ConvertLocalTimeGet(
    location,
    task.plan_finish_time,
    'DD-MM-YYYY HH:mm'
  )
  const actualStart = ConvertLocalTimeGet(
    location,
    task.actual_start_time,
    'DD-MM-YYYY HH:mm'
  )
  const actualFinish = ConvertLocalTimeGet(
    location,
    task.actual_finish_time,
    'DD-MM-YYYY HH:mm'
  )

  // The user can't update/edit tasks if the activity is not checked
  // The user can't update/edit tasks if the activity is not checked
  const isChecked = (() => {
    return activity.start_date ? true : false
  })()

  const isManualActivity = (() => activity.activity_type === 'Manual')()
  const isNotApplicableTask = (() => task.level_value === 'Not Applicable')()
  const isChecklistActivity = (() => activity.activity_type === 'Checklist')()
  const isAllowedDeleteTask = (() => activity.is_allowed_delete_task)()
  const isAllowedCurrentTask = (() => activity.is_allowed_current_task)()

  const open = Boolean(anchorEl)

  const handlePopoverClose = () => setAnchorEl(null)
  const handlePopoverOpen = (task) => (event) => {
    setAnchorEl(event.currentTarget)
    setSelectedTask(task)
  }

  return (
    <tr
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
      style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
      id={`exct-mdl-act-inview-tr-${index}`}
    >
      {isManualActivity && (
        <SC.InnerGridActionCell>
          <div id={`exct-mdl-act-inview-delete-btn-${index}`}>
            <SC.DeleteIcon
              disable={!isChecked}
              onClick={(isChecked) && (() => deleteTask(activity, task))}
            />
          </div>
          <div id={`exct-mdl-act-inview-edit-btn-${index}`}>
            <SC.EditIcon
              disable={!isChecked}
              onClick={(isChecked) && (() => toggleEditMode(activity, task))}
            />
          </div>
        </SC.InnerGridActionCell>
      )}
      {isChecklistActivity && (
        <SC.InnerGridActionCell>
          <div id={`exct-mdl-act-inview-delete-btn-${index}`}>
            <SC.DeleteIcon
              disable={!isAllowedDeleteTask || isNotApplicableTask}
              onClick={(isAllowedDeleteTask && !isNotApplicableTask) && (() => deleteTask(activity, task))}
            />
          </div>
          <div id={`exct-mdl-act-inview-edit-btn-${index}`}>
            <SC.EditIcon
              disable={!isAllowedCurrentTask}
              onClick={(isAllowedCurrentTask) && (() => toggleEditMode(activity, task))}
            />
          </div>
        </SC.InnerGridActionCell>
      )}
      <td style={{ textAlign: 'center' }}>{index + 1}.</td>
      <td>
        <div style={{ display: 'flex', width: 150, justifyContent: 'space-between' }}>
          {task.task}
          {(task?.requirement || task?.compliance_parameter) && (
            <span id={`exct-mdl-act-inview-popover-exclamation-icon-${index}`}>
              <SC.IconWrapper>
                <SC.ExclamationIcon src={Images.ExclamationIcon} onClick={handlePopoverOpen(task)} />
              </SC.IconWrapper>
              <Popover
                open={open}
                task={selectedTask}
                anchorEl={anchorEl}
                handlePopoverClose={handlePopoverClose}
              />
            </span>
          )}
        </div>
      </td>
      {activity.activity_type === 'Checklist' && (
        <>
          <td width='200px'>{task.pic}</td>
          <td width='175px'>{task.level_value}</td>
          <td width='150px'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <SC.StatusCheckboxWrapper>
                <Checkbox
                  id={`status-green-${index}`}
                  checked={task.is_green === true}
                  disabled
                />
              </SC.StatusCheckboxWrapper>
              <SC.StatusCheckboxWrapper>
                <Checkbox
                  id={`status-orange-${index}`}
                  checked={task.is_orange === true}
                  disabled
                />
              </SC.StatusCheckboxWrapper>
              <SC.StatusCheckboxWrapper>
                <Checkbox
                  id={`status-red-${index}`}
                  checked={task.is_red === true}
                  disabled
                />
              </SC.StatusCheckboxWrapper>
            </div>
            {task.status_note && <SC.ErrorLabel>{task.status_note}</SC.ErrorLabel>}
          </td>
        </>
      )}
      <td>
        {planStart && planFinish ? (
          <>
            <p style={{ margin: 0 }}>{planStart} -</p>
            <p style={{ margin: 0 }}>{planFinish}</p>
          </>
        ) : null}
      </td>
      <td width='300px'>
        <div style={{ height: 82, display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
          <span>{task.remarks}</span>
          {task.remarks_note && <SC.ErrorLabel>{task.remarks_note}</SC.ErrorLabel>}
        </div>
      </td>
      <td>{actualStart}</td>
      <td>{actualFinish}</td>
      {activity.activity_type === 'Manual' && (
        <td>{task.percentage}</td>
      )}
      <SC.ActionCell>
        <SC.ActionCellContainer justifyContent={task.attachment_note ? 'space-between' : 'center'}>
          <SC.ActionCellWrapper>
            {activity.activity_type === 'Checklist' && (
              <SC.ActionIconWrapper
                onClick={() => toggleModalTaskAttachment('view', task, activity)}
                id={`exct-mdl-act-inview-folder-document-btn-${index}`}
              >
                <FolderDocument color={Colors.limeGreen} />
                <span>({task.progress_task_attachment_list ? task.progress_task_attachment_list.length : 0})</span>
              </SC.ActionIconWrapper>
            )}

            <SC.ActionIconWrapper
              disable={isManualActivity ? !isChecked : false}
              id={`exct-mdl-act-inview-equipment-btn-${index}`}
              onClick={
                (isManualActivity ? isChecked : true) &&
                (() => handleShowModal(activity.code, activity.sr_code, task.code, task.task))
              }
            >
              <EquipmentIcon
                width='20px'
                height='20px'
                color={(isManualActivity ? isChecked : true) ? Colors.softBlue : Colors.softGrey}
              />
              <span>({task.progress_task_detail_list ? task.progress_task_detail_list.length : 0})</span>
            </SC.ActionIconWrapper>
          </SC.ActionCellWrapper>
          {task.attachment_note && <SC.ErrorLabel>{task.attachment_note}</SC.ErrorLabel>}
        </SC.ActionCellContainer>
      </SC.ActionCell>
    </tr>
  )
}

const InEditTaskHeaderRow = ({
  task,
  index,
  activity,
  location,
  provided,
  snapshot,
  getItemStyle,
  toggleEditMode,
  handleShowModal,
  taskLevelOptions,
  updateChecklistTask,
  toggleModalTaskAttachment,
  updateActivityAndTaskHeader
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedTask, setSelectedTask] = useState()

  const now = new Date(moment().subtract(1, 'm').toISOString())
  const taskHeaderList = activity.progress_task_header_list ?? []

  const planStart = ConvertLocalTimeGet(
    location,
    task.plan_start_time,
    'DD-MM-YYYY HH:mm'
  )
  const planFinish = ConvertLocalTimeGet(
    location,
    task.plan_finish_time,
    'DD-MM-YYYY HH:mm'
  )

  const actualStart = ConvertLocalTimeGet(
    location,
    task.actual_start_time,
    'DD-MM-YYYY HH:mm'
  )
  const actualFinish = ConvertLocalTimeGet(
    location,
    task.actual_finish_time,
    'DD-MM-YYYY HH:mm'
  )

  const handleUpdateActivityManualTask = (values, setFieldError) => {
    try {
      // Adjusting the previous task header list to the newly updated task header
      const updatedTaskHeaderList = taskHeaderList.map((ts) => {
        if (ts.code === task.code) return { ...ts, ...values }
        return ts
      })

      // Prevent the list of tasks has overall progress more than 100% times the number of tasks in total
      const { isExceed100, progress } = Funcs.checkTasksPercentage(
        updatedTaskHeaderList,
        activity.percentage || 0
      )
      if (isExceed100) {
        setFieldError('percentage', 'Can not exceed 100% in total')
        return
      }

      const finishDate = Funcs.findTheLatestDateFromTasksList(
        updatedTaskHeaderList
      )
      const updatedActivity = {
        ...activity,
        progress,
        start_date: activity.start_date,
        finish_date: ConvertLocalTimePost(location, finishDate),
        modified_date: ConvertLocalTimePost(location, new Date())
      }
      const updatedTask = {
        ...task,
        ...values,
        actual_start_time: ConvertLocalTimePost(
          location,
          values.actual_start_time
        ),
        actual_finish_time: ConvertLocalTimePost(
          location,
          values.actual_finish_time
        ),
        modified_date: ConvertLocalTimePost(location, new Date())
      }
      updateActivityAndTaskHeader(updatedActivity, updatedTask)
    } catch (error) {
      return error
    }
  }

  const handleUpdateActivityChecklistTask = (values) => {
    try {
      const payload = {
        id: task.id,
        pic: values.pic,
        code: task.code,
        task: values.task,
        level: values.level,
        is_red: values.is_red,
        sort_no: task.sort_no,
        sr_code: task.sr_code,
        remarks: values.remarks,
        is_green: values.is_green,
        is_orange: values.is_orange,
        percentage: 0,
        requirement: task.requirement,
        level_value: values.level_value,
        activity_code: activity.code,
        compliance_parameter: task.compliance_parameter,
        actual_start_time: ConvertLocalTimePost(
          location,
          values.actual_start_time
        ),
        actual_finish_time: ConvertLocalTimePost(
          location,
          values.actual_finish_time
        ),
        modified_date: ConvertLocalTimePost(location, new Date()),
        progress_task_attachment_list: task.progress_task_attachment_list,
      }
      updateChecklistTask(activity, payload)
    } catch (error) {
      return error
    }
  }

  let validationSchema = Yup.object({
    task: Yup.string().required('This field is required'),
  })

  if (activity.activity_type === 'Manual') {
    validationSchema = validationSchema.shape({
      percentage: Yup.number().max(100, 'Can not exceed 100%'),
      actual_start_time: Yup
        .date()
        .min(
          new Date(activity.start_date ?? now),
          'Must be later than activity start date'
        )
        .test(
          'Estimate_Start_Time',
          'Must filled when finish time not empty',
          (value) => {
            if (taskHeaderForm.values.actual_finish_time) {
              if (value) {
                return true
              } else {
                return false
              }
            } else {
              return true
            }
          }
        )
        .nullable()
    })
  }

  if (activity.activity_type === 'Checklist') {
    validationSchema = validationSchema.shape({
      pic: Yup.string().required('This field is required'),
      level_value: Yup.string().required('This field is required'),
    })
  }

  validationSchema = validationSchema.shape({
    actual_finish_time: Yup
      .date()
      .test(
        'Estimate_Finish_Time',
        'Must be greater than actual start time',
        (value) => {
          if (value && taskHeaderForm.values.actual_start_time) {
            const endTime = moment(value).format('DD MMM YYYY HH:mm')
            const startTime = moment(
              taskHeaderForm.values.actual_start_time
            ).format('DD MMM YYYY HH:mm')
            const duration = moment
              .duration(
                moment(endTime, 'DD MMM YYYY HH:mm').diff(
                  moment(startTime, 'DD MMM YYYY HH:mm')
                )
              )
              .asSeconds()

            return duration >= 0 ? true : false
          } else {
            return true
          }
        }
      )
      .nullable(),
  })
  const taskHeaderForm = useFormik({
    initialValues: {
      pic: task.pic ?? '',
      task: task.task ?? '',
      level: task.level ?? '',
      is_red: task.is_red ?? false,
      remarks: task.remarks ?? '',
      is_green: task.is_green ?? false,
      is_orange: task.is_orange ?? false,
      percentage: task.percentage ?? 0,
      level_value: task.level_value ?? '',
      actual_start_time:
        ConvertLocalTimeGet(
          location,
          task.actual_start_time,
          'YYYY-MM-DD HH:mm'
        ) ?? '',
      actual_finish_time:
        ConvertLocalTimeGet(
          location,
          task.actual_finish_time,
          'YYYY-MM-DD HH:mm'
        ) ?? ''
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setFieldError }) => {
      if (activity.activity_type === 'Manual') {
        handleUpdateActivityManualTask(values, setFieldError)
      } else {
        handleUpdateActivityChecklistTask(values, setFieldError)
      }
    }
  })

  const isTaskCompleted = (() => activity.is_task_completed)()
  const isNotApplicableTask = (() => task.level_value === 'Not Applicable')()
  const isChecklistActivity = (() => activity.activity_type === 'Checklist')()

  const open = Boolean(anchorEl)

  const handlePopoverClose = () => setAnchorEl(null)
  const handlePopoverOpen = (task) => (event) => {
    setAnchorEl(event.currentTarget)
    setSelectedTask(task)
  }

  return (
    <tr
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
      style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
    >
      <SC.InnerGridActionCell>
        <div id={`exct-mdl-act-inedit-save-btn-${index}`}>
          <SC.SaveIcon onClick={taskHeaderForm.handleSubmit} />
        </div>
        <div id={`exct-mdl-act-inedit-cancel-btn-${index}`}>
          <SC.CancelIcon onClick={() => toggleEditMode(activity, task)} />
        </div>
      </SC.InnerGridActionCell>
      <td style={{ textAlign: 'center' }}>{index + 1}.</td>
      {isChecklistActivity && (isTaskCompleted || isNotApplicableTask) ? (
        <td>
          <div style={{ display: 'flex', width: 150, justifyContent: 'space-between' }}>
            {task.task}
            {(task?.requirement || task?.compliance_parameter) && (
              <span id={`exct-mdl-act-inedit-popover-exclamation-icon-${index}`}>
                <SC.IconWrapper>
                  <SC.ExclamationIcon src={Images.ExclamationIcon} onClick={handlePopoverOpen(task)} />
                </SC.IconWrapper>
                <Popover
                  open={open}
                  task={selectedTask}
                  anchorEl={anchorEl}
                  handlePopoverClose={handlePopoverClose}
                />
              </span>
            )}
          </div>
        </td>
      ) : (
        <td>
          <Input
            id={`exct-mdl-act-inedit-input-task-${index}`}
            form={taskHeaderForm}
            name='task'
            tabIndex={1}
            placeholder='Task'
          />
        </td>
      )}
      {isChecklistActivity && (
        <>
          {(isTaskCompleted || isNotApplicableTask) ? (
            <td width='200px'>{task.pic}</td>
          ) : (
            <td>
              <Input
                id={`exct-mdl-act-inedit-input-pic-${index}`}
                form={taskHeaderForm}
                name='pic'
                tabIndex={1}
                variant='outlined'
                placeholder='PIC'
                disable={isTaskCompleted}
              />
            </td>
          )}
          {(isTaskCompleted || isNotApplicableTask) ? (
            <td width='175px'>{task.level_value}</td>
          ) : (
            <td>
              <InputSelect
                id={`exct-mdl-act-inedit-input-level-${index}`}
                form={taskHeaderForm}
                name='level_value'
                value={taskLevelOptions.find((e) => e['Code'] === taskHeaderForm.values.level_value)}
                variant='outlined'
                options={taskLevelOptions}
                readOnly={isTaskCompleted}
                optionText='Value'
                optionValueKey='Value'
                onChange={(_, val) => {
                  taskHeaderForm.setFieldValue('level', val ? val['Code'] : '')
                  taskHeaderForm.setFieldValue('level_value', val ? val['Value'] : '')
                }}
              />
            </td>
          )}
          <td>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <SC.StatusCheckboxWrapper>
                <Checkbox
                  id={`status-green-${index}`}
                  form={taskHeaderForm}
                  checked={taskHeaderForm.values.is_green === true}
                  disabled={isTaskCompleted || isNotApplicableTask}
                  onChange={() => {
                    taskHeaderForm.setFieldValue('is_red', false)
                    taskHeaderForm.setFieldValue('is_green', !taskHeaderForm.values.is_green)
                    taskHeaderForm.setFieldValue('is_orange', false)
                  }}
                />
              </SC.StatusCheckboxWrapper>
              <SC.StatusCheckboxWrapper>
                <Checkbox
                  id={`status-orange-${index}`}
                  form={taskHeaderForm}
                  checked={taskHeaderForm.values.is_orange === true}
                  disabled={isTaskCompleted || isNotApplicableTask}
                  onChange={() => {
                    taskHeaderForm.setFieldValue('is_red', false)
                    taskHeaderForm.setFieldValue('is_green', false)
                    taskHeaderForm.setFieldValue('is_orange', !taskHeaderForm.values.is_orange)
                  }}
                />
              </SC.StatusCheckboxWrapper>
              <SC.StatusCheckboxWrapper>
                <Checkbox
                  id={`status-red-${index}`}
                  form={taskHeaderForm}
                  checked={taskHeaderForm.values.is_red === true}
                  disabled={isTaskCompleted || isNotApplicableTask}
                  onChange={() => {
                    taskHeaderForm.setFieldValue('is_red', !taskHeaderForm.values.is_red)
                    taskHeaderForm.setFieldValue('is_green', false)
                    taskHeaderForm.setFieldValue('is_orange', false)
                  }}
                />
              </SC.StatusCheckboxWrapper>
            </div>
          </td>
        </>
      )}
      <td>
        <p>{planStart} -</p>
        <p>{planFinish}</p>
      </td>
      {isChecklistActivity && (isTaskCompleted || isNotApplicableTask) ? (
        <td width='300px'>{task.remarks}</td>
      ) : (
        <td>
          <Input
            id={`exct-mdl-act-inedit-input-remarks-${index}`}
            name='remarks'
            form={taskHeaderForm}
            disable={isTaskCompleted && isChecklistActivity}
            tabIndex={2}
            placeholder='Remarks'
          />
        </td>
      )}

      {isNotApplicableTask ? (
        <td>{actualStart}</td>
      ) : (
        <td>
          <InputDateTime
            tabIndex={3}
            readOnly={false}
            form={taskHeaderForm}
            name='actual_start_time'
            id={`exct-mdl-act-inedit-input-actual_start_time-${index}`}
          />
        </td>
      )}

      {isNotApplicableTask ? (
        <td>{actualFinish}</td>
      ) : (
        <td>
          <InputDateTime
            tabIndex={4}
            readOnly={false}
            form={taskHeaderForm}
            name='actual_finish_time'
            id={`exct-mdl-act-inedit-input-actual_finish_time-${index}`}
          />
        </td>
      )}
      {activity.activity_type === 'Manual' && (
        <td>
          <Input
            tabIndex={5}
            type='number'
            name='percentage'
            form={taskHeaderForm}
            placeholder='Percentage'
            id={`exct-mdl-act-inedit-input-percentage-${index}`}
          />
        </td>
      )}
      <SC.ActionCell>
        <SC.ActionCellContainer>
          {activity.activity_type === 'Checklist' && (
            <SC.ActionIconWrapper
              onClick={() => toggleModalTaskAttachment('edit', task, activity)}
              id={`exct-mdl-act-inedit-folder-document-btn-${index}`}
            >
              <FolderDocument />
              <span>({task.progress_task_attachment_list ? task.progress_task_attachment_list.length : 0})</span>
            </SC.ActionIconWrapper>
          )}
          <SC.ActionIconWrapper
            id={`exct-mdl-act-inedit-equipment-btn-${index}`}
            onClick={() => handleShowModal(activity.code, activity.sr_code, task.code, task.task)}
          >
            <EquipmentIcon width='20px' height='20px' color={Colors.softBlue} />
            <span>({task.progress_task_detail_list ? task.progress_task_detail_list.length : 0})</span>
          </SC.ActionIconWrapper>
        </SC.ActionCellContainer>
      </SC.ActionCell>
    </tr>
  )
}

const TaskList = ({
  activity,
  location,
  deleteTask,
  attachmentList,
  toggleEditMode,
  handleShowModal,
  progressTaskList,
  taskLevelOptions,
  updateChecklistTask,
  toggleModalTaskAttachment,
  updateActivityAndTaskHeader
}) => {
  const getItemStyle = (isDragging, draggableStyle) => ({
    display: isDragging ? 'table' : '',
    background: isDragging ? '#ddd' : '',

    // styles we need to apply on draggables
    ...draggableStyle
  })

  return progressTaskList.map((task, index) => (
    <Draggable
      key={task.id}
      index={index}
      draggableId={`draggable-task-${task.id}`}
    >
      {(provided, snapshot) =>
        task.inEdit ? ( // If you don't find this task.inEdit initialization when fetching activity data, it's implicitly false
          <InEditTaskHeaderRow
            index={index}
            task={task}
            key={task.id}
            location={location}
            provided={provided}
            snapshot={snapshot}
            activity={activity}
            getItemStyle={getItemStyle}
            attachmentList={attachmentList}
            toggleEditMode={toggleEditMode}
            handleShowModal={handleShowModal}
            taskLevelOptions={taskLevelOptions}
            updateChecklistTask={updateChecklistTask}
            toggleModalTaskAttachment={toggleModalTaskAttachment}
            updateActivityAndTaskHeader={updateActivityAndTaskHeader}
          />
        ) : (
          <InViewTaskHeaderRow
            index={index}
            task={task}
            key={task.id}
            location={location}
            provided={provided}
            snapshot={snapshot}
            activity={activity}
            deleteTask={deleteTask}
            getItemStyle={getItemStyle}
            toggleEditMode={toggleEditMode}
            handleShowModal={handleShowModal}
            toggleModalTaskAttachment={toggleModalTaskAttachment}
          />
        )
      }
    </Draggable>
  ))
}

const DetailGridBody = ({
  index,
  activity,
  location,
  onDragEnd,
  addNewTask,
  deleteTask,
  toggleEditMode,
  handleShowModal,
  progressTaskList,
  taskLevelOptions,
  attachmentList,
  updateChecklistTask,
  toggleModalTaskAttachment,
  updateActivityAndTaskHeader
}) => (
  <DragDropContext onDragEnd={(result) => onDragEnd(result, activity)}>
    <Droppable droppableId={`droppable-activity-${activity.id}`}>
      {(provided) => (
        <tbody {...provided.droppableProps} ref={provided.innerRef}>
          {progressTaskList.length === 0 && (
            <EmptyList colSpan={activity.activity_type === 'Manual' ? 6 : 11} text='No Tasks' />
          )}

          {progressTaskList.length > 0 && (
            <TaskList
              location={location}
              activity={activity}
              deleteTask={deleteTask}
              toggleEditMode={toggleEditMode}
              attachmentList={attachmentList}
              handleShowModal={handleShowModal}
              progressTaskList={progressTaskList}
              taskLevelOptions={taskLevelOptions}
              updateChecklistTask={updateChecklistTask}
              toggleModalTaskAttachment={toggleModalTaskAttachment}
              updateActivityAndTaskHeader={updateActivityAndTaskHeader}
            />
          )}

          {activity.activity_type === 'Manual' && (
            <Draggable
              isDragDisabled
              index={progressTaskList.length}
              draggableId={`draggable-task-${progressTaskList.length + 1}`}
            >
              {(prov) => (
                <AddTaskRow
                  index={index}
                  provided={prov}
                  activity={activity}
                  addNewTask={addNewTask}
                />
              )}
            </Draggable>
          )}
          {provided.placeholder}
        </tbody>
      )}
    </Droppable>
  </DragDropContext>
)

// DetailGrid
const DetailGrid = ({
  index,
  activity,
  location,
  onDragEnd,
  addNewTask,
  deleteTask,
  attachmentList,
  toggleEditMode,
  setActivityList,
  handleShowModal,
  progressTaskList,
  taskLevelOptions,
  updateChecklistTask,
  toggleModalTaskAttachment,
  updateActivityAndTaskHeader
}) => (
  <SC.BodyRowGridDetail>
    <SC.DetailGridCell colSpan={5}>
      <SC.InnerGrid>
        <DetailGridHeader
          activity={activity}
          setActivityList={setActivityList}
        />
        <DetailGridBody
          index={index}
          location={location}
          activity={activity}
          onDragEnd={onDragEnd}
          addNewTask={addNewTask}
          deleteTask={deleteTask}
          attachmentList={attachmentList}
          toggleEditMode={toggleEditMode}
          handleShowModal={handleShowModal}
          progressTaskList={progressTaskList}
          taskLevelOptions={taskLevelOptions}
          updateChecklistTask={updateChecklistTask}
          toggleModalTaskAttachment={toggleModalTaskAttachment}
          updateActivityAndTaskHeader={updateActivityAndTaskHeader}
        />
      </SC.InnerGrid>
    </SC.DetailGridCell>
  </SC.BodyRowGridDetail>
)

// ActivityRow
const ActivityRow = ({
  index,
  location,
  activity,
  onDragEnd,
  addNewTask,
  deleteTask,
  updateActivity,
  toggleEditMode,
  attachmentList,
  setActivityList,
  handleShowModal,
  toggleModalTask,
  taskLevelOptions,
  updateChecklistTask,
  handleOpenActivityDetail,
  toggleModalTaskAttachment,
  handleCheckProgressActivity,
  updateActivityAndTaskHeader
}) => {
  const [startDate, setStartDate] = useState(
    ConvertLocalTimeGet(location, activity.start_date, 'YYYY-MM-DD HH:mm')
  )

  const handleChangeStartDate = (values) => {
    if (values !== null) {
      setStartDate(values)
    }
  }

  const handleBlur = () => {
    if (startDate !== null) {
      updateActivity({
        ...activity,
        progress_task_header_list: null,
        modified_date: ConvertLocalTimePost(location, new Date()),
        start_date: ConvertLocalTimePost(location, moment(startDate).format())
      })
    }
  }

  const isChecked = (() => {
    return activity.start_date ? true : false
  })()

  useEffect(() => {
    setStartDate(
      ConvertLocalTimeGet(location, activity.start_date, 'YYYY-MM-DD HH:mm')
    )
  }, [activity.start_date])

  const isAllowedAddTask = (() => activity.progress !== 100)()

  return (
    <>
      <SC.BodyRowGrid showNextRow={activity.isOpen} key={activity.id}>
        <ListActivityCell
          index={index}
          activity={activity}
          location={location}
          handleOpenActivityDetail={handleOpenActivityDetail}
          handleCheckProgressActivity={handleCheckProgressActivity}
        />
        <td>
          <InputDateTime
            readOnly={!isChecked}
            tabIndex={2}
            value={startDate}
            shouldUseOnChange
            name='actual_start_time'
            onChange={handleChangeStartDate}
            onBlur={handleBlur}
            id={`exct-mdl-act-date-actual_start_time-${index}`}
          />
        </td>
        <td>
          {ConvertLocalTimeGet(
            location,
            activity.finish_date,
            'DD-MM-YYYY HH:mm'
          )}
        </td>
        {activity.activity_type === 'Manual' && (
          <td>{activity.progress ?? 0} of {activity.percentage}%</td>
        )}
        {activity.activity_type === 'Checklist' && (
          <td>{activity.progress}</td>
        )}
        <td />
      </SC.BodyRowGrid>

      {activity.activity_type === 'Checklist' && (
        <SC.BodyRowGridDetail>
          <SC.RegularGridCell colSpan={4}>Task</SC.RegularGridCell>
          <SC.RegularGridCell>
            <Button
              id={`exct-mdl-act-add-task-checklist-btn-${index}`}
              color={isAllowedAddTask ? 'blue' : 'grey'}
              disable={!isAllowedAddTask}
              onClick={isAllowedAddTask && (() => toggleModalTask(activity))}
            >
              <AddIcon /> Add Task
            </Button>
          </SC.RegularGridCell>
        </SC.BodyRowGridDetail>
      )}

      {activity.isOpen && (
        <DetailGrid
          index={index}
          location={location}
          activity={activity}
          onDragEnd={onDragEnd}
          addNewTask={addNewTask}
          deleteTask={deleteTask}
          attachmentList={attachmentList}
          toggleEditMode={toggleEditMode}
          handleShowModal={handleShowModal}
          setActivityList={setActivityList}
          taskLevelOptions={taskLevelOptions}
          updateChecklistTask={updateChecklistTask}
          toggleModalTaskAttachment={toggleModalTaskAttachment}
          updateActivityAndTaskHeader={updateActivityAndTaskHeader}
          progressTaskList={activity.progress_task_header_list || []}
        />
      )}
    </>
  )
}

const ActivityList = ({
  location,
  onDragEnd,
  addNewTask,
  deleteTask,
  activityList,
  toggleEditMode,
  updateActivity,
  setActivityList,
  handleShowModal,
  attachmentList,
  toggleModalTask,
  taskLevelOptions,
  updateChecklistTask,
  handleOpenActivityDetail,
  toggleModalTaskAttachment,
  handleCheckProgressActivity,
  updateActivityAndTaskHeader
}) => {
  return activityList.map((activity, index) => (
    <ActivityRow
      index={index}
      key={activity.id}
      location={location}
      activity={activity}
      onDragEnd={onDragEnd}
      addNewTask={addNewTask}
      deleteTask={deleteTask}
      attachmentList={attachmentList}
      updateActivity={updateActivity}
      toggleEditMode={toggleEditMode}
      toggleModalTask={toggleModalTask}
      handleShowModal={handleShowModal}
      setActivityList={setActivityList}
      taskLevelOptions={taskLevelOptions}
      updateChecklistTask={updateChecklistTask}
      handleOpenActivityDetail={handleOpenActivityDetail}
      toggleModalTaskAttachment={toggleModalTaskAttachment}
      handleCheckProgressActivity={handleCheckProgressActivity}
      updateActivityAndTaskHeader={updateActivityAndTaskHeader}
    />
  ))
}

const BodyGrid = ({
  location,
  onDragEnd,
  addNewTask,
  deleteTask,
  activityList,
  updateActivity,
  toggleEditMode,
  attachmentList,
  setActivityList,
  handleShowModal,
  toggleModalTask,
  taskLevelOptions,
  updateChecklistTask,
  handleOpenActivityDetail,
  toggleModalTaskAttachment,
  handleCheckProgressActivity,
  updateActivityAndTaskHeader
}) => (
  <tbody>
    {activityList.length === 0 ? (
      <EmptyList text='No Activities' />
    ) : (
      <ActivityList
        location={location}
        onDragEnd={onDragEnd}
        addNewTask={addNewTask}
        deleteTask={deleteTask}
        activityList={activityList}
        attachmentList={attachmentList}
        updateActivity={updateActivity}
        toggleEditMode={toggleEditMode}
        handleShowModal={handleShowModal}
        setActivityList={setActivityList}
        toggleModalTask={toggleModalTask}
        taskLevelOptions={taskLevelOptions}
        updateChecklistTask={updateChecklistTask}
        handleOpenActivityDetail={handleOpenActivityDetail}
        toggleModalTaskAttachment={toggleModalTaskAttachment}
        handleCheckProgressActivity={handleCheckProgressActivity}
        updateActivityAndTaskHeader={updateActivityAndTaskHeader}
      />
    )}
  </tbody>
)

// ActivityGrid
const ActivityGrid = ({
  location,
  onDragEnd,
  addNewTask,
  deleteTask,
  activityList,
  toggleEditMode,
  updateActivity,
  attachmentList,
  setActivityList,
  handleShowModal,
  toggleModalTask,
  taskLevelOptions,
  updateChecklistTask,
  handleOpenActivityDetail,
  toggleModalTaskAttachment,
  handleCheckProgressActivity,
  updateActivityAndTaskHeader,
}) => (
  <SC.GridContainer>
    <SC.Grid>
      <HeaderGrid />
      <BodyGrid
        location={location}
        onDragEnd={onDragEnd}
        deleteTask={deleteTask}
        addNewTask={addNewTask}
        activityList={activityList}
        updateActivity={updateActivity}
        attachmentList={attachmentList}
        toggleEditMode={toggleEditMode}
        handleShowModal={handleShowModal}
        setActivityList={setActivityList}
        toggleModalTask={toggleModalTask}
        taskLevelOptions={taskLevelOptions}
        updateChecklistTask={updateChecklistTask}
        handleOpenActivityDetail={handleOpenActivityDetail}
        toggleModalTaskAttachment={toggleModalTaskAttachment}
        handleCheckProgressActivity={handleCheckProgressActivity}
        updateActivityAndTaskHeader={updateActivityAndTaskHeader}
      />
    </SC.Grid>
  </SC.GridContainer>
)

const WarningModal = ({
  dataAll,
  notConfirm,
  openWarning,
  isInProgress,
  setNotConfirm,
  setOpenWarning,
  totalPercentage
}) => {
  const message = (() => {
    if (notConfirm) {
      return 'Your Request has not been Confirmed yet'
    }

    if (totalPercentage < 100 && isInProgress) {
      return 'Activity Percentage not 100% and Vessel is still In Progress'
    }

    if (isInProgress) {
      return 'Vessel is still In Progress'
    }

    if (dataAll.Contract_No === '') {
      return 'Please Insert Agreement Number First'
    }

    return 'Activity Percentage have not reach 100% yet'
  })()

  return (
    <ModalConfirmation
      isWarn={true}
      open={openWarning}
      close={() => {
        setNotConfirm(false)
        setOpenWarning(false)
      }}
      title='ATTENTION !!'
      message={message}
      icon={
        <ErrorOutlineRoundedIcon
          style={{ fontSize: '60px', color: '#eed202' }}
        />
      }
    />
  )
}

const SortModal = ({
  setDataSortChild,
  dataSort,
  setModalChild,
  activity,
  setActivityList
}) => {
  const dataDropdown = [
    { field: 'task', name: 'Task', id: 1, dir: 'asc' },
    { field: 'plan_start_time', name: 'Planning', id: 2, dir: 'asc' },
    { field: 'actual_start_time', name: 'Start Date', id: 3, dir: 'asc' },
    { field: 'actual_finish_time', name: 'Finish Date', id: 4, dir: 'asc' },
    { field: 'percentage', name: 'Percentage', id: 5, dir: 'asc' },
    { field: 'remarks', name: 'Remarks', id: 6, dir: 'asc' }
  ]

  const dataFilterModule = () => {
    var dataSlice = dataDropdown
    dataSort.forEach((datal) => {
      const index = dataDropdown.findIndex((item) => item.id == datal.id)
      dataSlice.splice(index, 1)
    })
    return dataSlice
  }

  const handleAdd = (event) => {
    const arr = [...dataSort]
    arr.push(event.target.value)
    setDataSortChild(arr)
  }

  const handleRemove = (event) => {
    const arr = dataSort.filter((item) => {
      return item.id != event.id
    })
    setDataSortChild(arr)
  }
  const handleSort = (event) => {
    const arr = dataSort.map((item) => {
      if (item.id == event.id) {
        if (item.dir == 'asc') {
          return { ...item, dir: 'desc' }
        } else {
          return { ...item, dir: 'asc' }
        }
      } else {
        return item
      }
    })
    setDataSortChild(arr)
  }

  const handleClose = () => {
    setModalChild(false)
  }

  const handleUpdate = async () => {
    const payload = {
      dataSort: dataSort,
      data: {
        activity_code: activity.code,
        sr_code: activity.sr_code,
        modified_date: new Date()
      },
      handleClose: () => setModalChild(false),
      setActivityList: setActivityList
    }
    await Funcs.updateSort(payload)
  }
  return (
    <SC.ModalSort>
      <div style={{ borderBottom: '1px solid black', width: '100%' }}>
        {dataSort.map((item, i) => (
          <SC.SortListWrapper key={i}>
            <SC.SortTextList>{item.name}</SC.SortTextList>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div>
                <img
                  src={Images.sortDirIcon}
                  style={{
                    height: '100%',
                    width: '100%',
                    transform: `rotate(${item.dir == 'asc' ? '0deg' : '180deg'
                      })`,
                    marginRight: 5,
                    cursor: 'pointer',
                    color: '#A3AAB6'
                  }}
                  onClick={() => handleSort(item)}
                />
              </div>
              <div>
                <img
                  src={Images.deleteIcon}
                  style={{
                    height: '100%',
                    width: '100%',
                    cursor: 'pointer',
                    color: '#A3AAB6'
                  }}
                  onClick={() => handleRemove(item)}
                />
              </div>
            </div>
          </SC.SortListWrapper>
        ))}
        <FormControl
          style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '10px 15px 0px'
          }}
          sx={{
            boxShadow: 'none',
            '.MuiOutlinedInput-notchedOutline': { border: 0 }
          }}
          size='small'
        >
          <Select
            disableUnderline
            displayEmpty={true}
            renderValue={() => '  + Add sort'}
            onChange={(e) => handleAdd(e)}
            style={{
              marginBottom: 5,
              backgroundColor: 'transparent !important'
            }}
          >
            {dataFilterModule().map((item, i) => (
              <MenuItem key={i} value={item}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div
        style={{
          margin: '10px 0 5px 0',
          direction: 'rtl',
          width: '100%',
          display: 'flex'
        }}
      >
        <SC.ButtonFilter onClick={handleUpdate}>Update</SC.ButtonFilter>
        <SC.ButtonClose onClick={handleClose}>Close</SC.ButtonClose>
      </div>
    </SC.ModalSort>
  )
}

export default {
  TopForm,
  WarningModal,
  ActivityGrid
}
